<template>
  <div>
    <v-toolbar flat color="white">
      <v-tabs div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab href="#" v-model="tabs" v-for="tab in tabs" :key="tab.name" @click="setActiveTabName(tab.name)">{{
          tab.displayName
        }}</v-tab>
      </v-tabs>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-text-field
        v-if="displayContents('incompleteInstalls')"
        v-model="pendingSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="
          $router.push({
            name: $route.name,
            query: {
              pendingOffset: $route.query.pendingOffset,
              resolvedOffset: $route.query.resolvedOffset,
              pendingSearch: pendingSearch,
              resolvedSearch: $route.query.resolvedSearch,
              records: $route.query.records,
            },
          })
        "
      ></v-text-field>
      <v-text-field
        v-if="displayContents('completeInstalls')"
        v-model="resolvedSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="
          $router.push({
            name: $route.name,
            query: {
              pendingOffset: $route.query.pendingOffset,
              resolvedOffset: $route.query.resolvedOffset,
              pendingSearch: $route.query.pendingSearch,
              resolvedSearch: resolvedSearch,
              records: $route.query.records,
            },
          })
        "
      ></v-text-field>
    </v-toolbar>
    <div v-if="displayContents('completeInstalls')">
      <!-- FUll Installation Modal -->
      <v-flex xs12 sm12 md12 lg12>
          <v-data-table
            :headers="completeInstallheaders"
            class="elevation-1"
            :rows-per-page-items="[$route.query.records]"
            :loading="loading"
            :items="completeInstallations"
            item-key="id"
            align-center
            disable-initial-sort
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon @click="viewModal(props.item)">launch</v-icon>
              </td>
              <td class="text-xs-center">{{ formatDate(props.item.createdAt) }}</td>
               <td class="text-xs-center" >
                <span v-if="props.item.installedBy">{{ props.item.installedBy.name }} {{ props.item.installedBy.surname }}</span>
              </td>
              <td class="text-xs-center">{{ props.item.location.locationDescription }}</td>
              <td class="text-xs-center">{{ props.item.installType }}</td>
              <td class="text-xs-center"><span  v-if="props.item.installationDevices">
                <span v-for="installDevice in props.item.installationDevices" :key="installDevice.id"> {{ installDevice.device.ponMac }} <span v-if="props.item.installationDevices.indexOf(installDevice)<props.item.installationDevices.length-1"> - </span></span>
               </span></td>           
              <td class="text-xs-center">
                <v-icon v-if="props.item.patchLead" color="green">done</v-icon>
                <v-icon v-else color="red">not_interested</v-icon>
              </td>
              <td class="text-xs-center">
                <v-icon v-if="props.item.ftthBox" color="green">done</v-icon>
                <v-icon v-else color="red">not_interested</v-icon>
              </td>
              <td class="text-xs-center">
                <v-icon v-if="props.item.labelling" color="green">done</v-icon>
                <v-icon v-else color="red">not_interested</v-icon>
              </td>
              <td class="text-xs-center">
                <v-icon v-if="props.item.mstConnection" color="green">done</v-icon>
                <v-icon v-else color="red">not_interested</v-icon>
              </td>
              <!-- <td class="text-xs-center">{{ props.item.passiveDataReading }}</td>
              <td class="text-xs-center">{{ props.item.passiveVideoReading }}</td>
              <td class="text-xs-center">{{ props.item.activeDataReading }}</td>
              <td class="text-xs-center">{{ props.item.activeVideoReading }}</td>
              <td class="text-xs-center" v-if="props.item.installedById !== null">
                {{ props.item.installedBy.name }} {{ props.item.installedBy.surname }}
              </td>
              <td v-else></td> -->
            </template>
            <template v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template
            >
          </v-data-table>
          <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
            <v-layout wrap>
              <v-flex xs12>
                <v-pagination
                  v-model="resolvedPage"
                  :length="Math.ceil(resolvedTotalItems / $route.query.records)"
                  :total-visible="7"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </div>
      </v-flex>
    </div>
    <div v-if="displayContents('incompleteInstalls')">
      <!-- FUll Installation Modal -->
      <v-flex xs12 sm12 md12 lg12>
          <v-data-table
            :headers="incompleteInstallheaders"
            class="elevation-1"
            :rows-per-page-items="[$route.query.records]"
            :loading="loading"
            :items="incompleteInstallations"
            item-key="id"
            align-center
            disable-initial-sort
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon @click="viewModal(props.item)">launch</v-icon>
              </td>
              <td class="text-xs-center">{{ formatDate(props.item.createdAt) }}</td>
               <td class="text-xs-center" >
                <span v-if="props.item.installedBy">{{ props.item.installedBy.name }} {{ props.item.installedBy.surname }}</span>
              </td>
              <td class="text-xs-center">{{ props.item.location.locationDescription }}</td>
              <td class="text-xs-center">{{ props.item.installType }}</td>
               <td class="text-xs-center"><span  v-if="props.item.installationDevices">
                <span v-for="installDevice in props.item.installationDevices" :key="installDevice.id"> {{ installDevice.device.ponMac }} <span v-if="props.item.installationDevices.indexOf(installDevice)<props.item.installationDevices.length-1"> - </span></span>
               </span></td> 
              <td class="text-xs-center">{{ props.item.incompleteReason }}</td>
              <td class="text-xs-center">{{ props.item.reasonExplanation }}</td>
            </template>
            <template v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template
            >
          </v-data-table>
          <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
            <v-layout wrap>
              <v-flex xs12>
                <v-pagination
                  v-model="pendingPage"
                  :length="Math.ceil(pendingTotalItems / $route.query.records)"
                  :total-visible="7"
                ></v-pagination>
              </v-flex>
            </v-layout>
          </div>
      </v-flex>
    </div>
    <v-dialog persistent v-model="addInstallationModal" max-width="1200px">
      <v-card v-if="installation !== null">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">VIEW INSTALLATION</h1>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            flat
            large
            @click="
              setActiveInstallTabName('installSummary'), (addInstallationModal = false);
              installation = {};
            "
            >X</v-btn
          >
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-tabs :key="key" div="tabs">
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab
              href="#"
              v-model="installTabs"
              v-for="tab in installTabs"
              :key="tab.name"
              @click="setActiveInstallTabName(tab.name)"
              ><span>{{ tab.displayName }}</span>
            </v-tab>
          </v-tabs>
        </v-toolbar>
        <v-card-text>
          <v-container xs12 grid-list-md>
            <v-layout wrap col v-if="displayInstallContents('installSummary')">
              <v-flex xs12>
                <h3>Install Information</h3>
              </v-flex>
              <v-flex xs3><h3 class="grey--text">Install Date:</h3></v-flex>
              <v-flex xs3
                ><h3 class="font-weight-light grey--text">{{ formatDate(installation.createdAt) }}</h3></v-flex
              >
              <v-flex xs3><h3 class="grey--text">Location:</h3></v-flex>
              <v-flex xs3
                ><h3 v-if="installation.location" class="font-weight-light grey--text">
                  {{ installation.location.locationDescription }}
                </h3></v-flex
              >
              <v-flex xs3><h3 class="grey--text">Installed By:</h3></v-flex>
              <v-flex xs3
                ><h3 class="font-weight-light grey--text" v-if="installation.installedById">
                  {{ installation.installedBy.name }} {{ installation.installedBy.surname }}
                </h3>
                <h3 class="font-weight-light grey--text" v-else>No Details</h3></v-flex
              >
              <v-flex xs3><h3 class="grey--text">Install Type:</h3></v-flex>
              <v-flex xs3
                ><h3 class="font-weight-light grey--text" v-if="installation.installType === 'ActivePassive'">
                  Active & Passive
                </h3>
                <h3 class="font-weight-light grey--text" v-else>{{ installation.installType }}</h3></v-flex
              >
              <v-flex mt-3 xs12 v-if="installation.connectionName || installation.connectionPassword">
                <h3>SSID</h3>
              </v-flex>
              <v-flex xs3 v-if="installation.connectionName || installation.connectionPassword"
                ><h3 class="grey--text">Name:</h3></v-flex
              >
              <v-flex xs3 v-if="installation.connectionName"
                ><h3 class="font-weight-light grey--text">
                  {{ installation.connectionName }}
                </h3></v-flex
              >
              <v-flex xs3 v-if="installation.connectionName || installation.connectionPassword"
                ><h3 class="grey--text">Password:</h3></v-flex
              >
              <v-flex xs3 v-if="installation.connectionPassword"
                ><h3 class="font-weight-light grey--text">
                  {{ installation.connectionPassword }}
                </h3></v-flex
              >
              <v-flex mt-3 xs12 v-if="installation.signOffName !== null">
                <h3>Customer Sign-Off</h3>
              </v-flex>
              <v-flex xs3><h3 class="grey--text">Signed Off By:</h3></v-flex>
              <v-flex xs3
                ><h3 class="font-weight-light grey--text">
                  {{ installation.signOffName }} {{ installation.signOffSurname }}
                </h3></v-flex
              >
              <v-flex xs3><h3 class="grey--text">Contact No:</h3></v-flex>
              <v-flex xs3
                ><h3 class="font-weight-light grey--text">{{ installation.signOffMobileNo }}</h3></v-flex
              >
              <v-flex xs3><h3 class="grey--text">Signature:</h3></v-flex>
              <v-flex xs3
                ><v-img
                  :key="key"
                  v-if="signOffSignature !== null"
                  max-width="50%"
                  max-height="50%"
                  :src="signOffSignature"
                ></v-img
              ></v-flex>
            </v-layout>

            <v-layout wrap col v-if="displayInstallContents('passiveInstall')">
              <!-- <v-flex xs12 sm12 md12 lg12 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'">
                      <h3>Passive Installation</h3>
                    </v-flex> -->
              <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                <v-switch readonly v-model="installation.patchLead" label="Patchlead"></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                <v-switch readonly v-model="installation.ftthBox" label="FTTH Box"></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                <v-switch readonly v-model="installation.labelling" label="Labelling"></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                <v-switch readonly v-model="installation.mstConnection" label="MST Connection"></v-switch>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                v-if="
                  installation.isPassiveInstall ||
                    installation.installType === 'Passive' ||
                    installation.installType === 'ActivePassive'
                "
              >
                <v-text-field
                  disabled
                  v-model="installation.passiveDataReading"
                  label="Passive Data Reading"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm6
                md4
                v-if="
                  installation.isPassiveInstall ||
                    installation.installType === 'Passive' ||
                    installation.installType === 'ActivePassive'
                "
              >
                <v-text-field
                  disabled
                  v-model="installation.passiveVideoReading"
                  label="Passive Video Reading"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-layout justify-center>
                  <v-flex
                    xs12
                    sm6
                    md4
                    v-if="
                      installation.isPassiveInstall ||
                        installation.installType === 'Passive' ||
                        (installation.installType === 'ActivePassive' && installation.passiveInstallPhoto !== null)
                    "
                  >
                    <v-layout justify-center v-if="installation.passiveInstallPhoto !== null">
                      <v-flex xs12>
                        <v-flex xs12>
                          <v-img :src="passiveInstallPhoto"></v-img>
                          <a download="passiveInstallPhoto.jpg" :href="passiveInstallPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>Complete Passive Install</h3></v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4
                    v-if="
                      installation.isPassiveInstall ||
                        installation.installType === 'Passive' ||
                        (installation.installType === 'ActivePassive' && installation.labellingPhoto !== null)
                    "
                  >
                    <v-layout justify-center v-if="installation.labellingPhoto !== null">
                      <v-flex xs12>
                        <v-flex xs12>
                          <v-img :src="labellingPhoto"></v-img>
                          <a download="mstLabellingPhoto.jpg" :href="labellingPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>MST Labelling</h3></v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout v-if="displayInstallContents('activeInstall')" wrap col justify-center>
            <!-- <v-flex xs12 sm12 md12 lg12 v-if="installation.isActiveInstall||installation.installType==='Active'||installation.installType==='ActivePassive'">
                      <h3>Active Installation</h3>
                    </v-flex> -->
            <v-flex
              xs3
              v-if="
                installation.isActiveInstall ||
                  installation.installType === 'Active' ||
                  installation.installType === 'ActivePassive'
              "
            >
              <v-text-field
                disabled
                v-model="installation.activeDataReading"
                label="Active Data Reading"
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex
              xs3
              v-if="
                installation.isActiveInstall ||
                  installation.installType === 'Active' ||
                  installation.installType === 'ActivePassive'
              "
            >
              <v-text-field
                disabled
                v-model="installation.activeVideoReading"
                label="Active Video Reading"
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-layout justify-center v-if="installation.ponmacPhoto !== null">
                <v-flex xs6>
                  <v-layout justify-center>
                    <v-flex xs12>
                      <v-flex xs12>
                        <v-img max-height="150px" :src="installation.ponmacPhoto"></v-img>
                        <a download="ponmacPhoto.jpg" :href="installation.ponmacPhoto">Download</a>
                      </v-flex>
                      <v-flex xs12><h3>PON MAC Photo</h3></v-flex>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout justify-center v-if="installation.activeInstallPhoto !== null">
                <v-flex xs6>
                  <v-layout justify-center>
                    <v-flex xs12>
                      <v-flex xs12>
                        <v-img max-height="150px" :key="key" :src="activeInstallPhoto"></v-img>
                        <a download="activeInstallPhoto.jpg" :href="activeInstallPhoto">Download</a>
                      </v-flex>
                      <v-flex xs12><h3>Complete Active Install</h3></v-flex>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              v-if="installation.installationDevices !== 'undefined' && installation.installationDevices.length > 0"
              ><h3>Installed Devices</h3></v-flex
            >
            <v-layout justify-center align-center v-if="installation.installationDevices !== 'undefined'">
              <v-flex xs4 v-for="device in installation.installationDevices" :key="device.deviceId">
                <v-card hover class="text-xs-center mb-2 mx-2 mt-2" @click="routeDevice(device.device)">
                  <div class="primary subheading text-uppercase white--text">
                    {{ device.device.deviceMakeModel.deviceMake.name }} {{ device.device.deviceMakeModel.name }}
                  </div>
                  <v-responsive></v-responsive>
                  <v-card-text>
                    <!-- <div class="grey--text">Make: {{device.device.deviceMakeModel.name}}</div> -->
                    <div class="grey--text">PON MAC: {{ device.device.ponMac }}</div>
                    <div class="grey--text">Serial Number: {{ device.device.serialNumber }}</div>
                    <!-- <div
                            class="grey--text"
                          >FSP: {{device.frame}}/{{device.slot}}/{{device.port}}</div>
                          <div class="grey--text">PON ID: {{device.ponId}}</div> -->
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
  props: ["allinstallations", "loading"],
  data() {
    return {
      activeInstallPhoto: null,
      signOffSignature: null,
      activeInstallPhoto: null,
      labellingPhoto: null,
      incompletePhoto: null,
      key: 0,
      completeInstallations: [],
      incompleteInstallations: [],
      pendingPage: 1,
      pendingPagination: {},
      pendingSearch: "",
      pendingTotalItems: 0,
      resolvedPage: 1,
      resolvedPagination: {},
      resolvedSearch: "",
      resolvedTotalItems: 0,
      installation: null,
      addInstallationModal: false,
      activeTabName: "",
      activeInstallTab: "",
      search: "",

      tabs: [
        { name: "completeInstalls", displayName: "Complete Installs" },
        { name: "incompleteInstalls", displayName: "Incomplete Installs" },
      ],
      installTabs: [],
      completeInstallheaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Installation Date",
          align: "center",
          value: "createdAt",
        },
        {
          text: 'Installer',
          align: 'center',
          value: 'installedBy.name'
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
        },
        {
          text: "Install Type",
          align: "center",
          value: "installType",
        },
        {
          text: "Device",
          align: "center",
          value: "device.ponMac",
        },
        {
          text: "Patch Lead",
          align: "center",
          value: "patchLead",
        },
        {
          text: "FTTH Box",
          align: "center",
          value: "ftthBox",
        },
        {
          text: "Labelling",
          align: "center",
          value: "labelling",
        },
        {
          text: "MST Connection",
          align: "center",
          value: "mstConnection",
        }
      ],
      incompleteInstallheaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Installation Date",
          align: "center",
          value: "createdAt",
        },
        {
          text: 'Installer',
          align: 'center',
          value: 'installedBy.name'
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
        },
        {
          text: "Install Type",
          align: "center",
          value: "installType",
        },
         {
          text: "Device",
          align: "center",
          value: "device.ponMac",
        },
        {
          text: "Incomplete Reason",
          align: "center",
          value: "incompleteReason",
        },
        {
          text: "Detail",
          align: "center",
          value: "reasonExplanation",
        }
      ],
    };
  },
  created() {
    this.$router.push({
      name: this.$route.name,
      query: {
        pendingOffset: "0",
        resolvedOffset: "0",
        records: "15",
      },
    });
    this.initialise();
  },
  watch: {
    // Pending
    "$route.query.pendingSearch": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (this.$route.query.pendingSearch && value !== "" && value != null) {
          this.pendingPage = 1;
          Api()
            .get("/installations/pending", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.incompleteInstallations = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        } else if (this.$route.query.pendingOffset) {
          Api()
            .get("/installations/pending", {
              params: {
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.incompleteInstallations = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    "$route.query.pendingOffset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.pendingSearch &&
          this.$route.query.pendingSearch != "" &&
          this.$route.query.pendingSearch !== null
        ) {
          Api()
            .get("/installations/pending", {
              params: {
                search: this.$route.query.pendingSearch,
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.incompleteInstallations = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        } else if (value != null) {
          Api()
            .get("/installations/pending", {
              params: {
                offset: this.$route.query.pendingOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.incompleteInstallations = response.data.result;
              this.pendingTotalItems = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    pendingPage(value) {
      this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch,
            },
          });
        }
      }
    },

    // Resolved
    "$route.query.resolvedSearch": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (this.$route.query.resolvedSearch && value !== "" && value != null) {
          this.resolvedPage = 1;
          Api()
            .get("/installations/resolved", {
              params: {
                search: this.$route.query.resolvedSearch,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.completeInstallations = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.isLoading = false;
            });
        } else if (this.$route.query.resolvedOffset) {
          Api()
            .get("/installations/resolved", {
              params: {
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.completeInstallations = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    "$route.query.resolvedOffset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.resolvedSearch &&
          this.$route.query.resolvedSearch != "" &&
          this.$route.query.resolvedSearch !== null
        ) {
          Api()
            .get("/installations/resolved", {
              params: {
                search: this.$route.query.resolvedSearch,
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.completeInstallations = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.isLoading = false;
            });
        } else if (value != null) {
          Api()
            .get("/installations/resolved", {
              params: {
                offset: this.$route.query.resolvedOffset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.completeInstallations = response.data.result;
              this.resolvedTotalItems = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    resolvedPage(value) {
      this.resolvedPagination.page = this.resolvedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              pendingSearch: this.$route.query.pendingSearch,
            },
          });
        }
      }
    },
  },
  methods: {
    async routeDevice(item) {
      // let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
        return el.url === "/devices/:deviceId";
      });
      if (route.length > 0) {
        await this.$store.dispatch("setCurrentRoute", route[0]);
        this.$router.push({ path: "/devices/" + item.id });
      } else {
        confirm("You do not have access to this module. Please request access from your admin.");
      }
    },
    viewModal(item) {
      this.installation = item;
       this.signOffSignature = this.installation.signOffSignature
        this.passiveInstallPhoto = this.installation.passiveInstallPhoto
         this.activeInstallPhoto = this.installation.activeInstallPhoto
          this.labellingPhoto = this.installation.labellingPhoto
           this.incompletePhoto = this.installation.incompletePhoto
      if (this.installation.signOffSignature && this.installation.signOffSignature != ""&&!this.installation.signOffSignature.includes('base64')) {
        Api()
          .post("/aws/s3/getObject", {
            url: this.installation.signOffSignature,
          })
          .then((response) => {
            this.signOffSignature = response.data;
            this.key++;
          });
      }
     
      if (this.installation.passiveInstallPhoto && this.installation.passiveInstallPhoto != "" &&!this.installation.passiveInstallPhoto.includes('base64')) {
        Api()
          .post("/aws/s3/getObject", {
            url: this.installation.passiveInstallPhoto,
          })
          .then((response) => {
            this.passiveInstallPhoto = response.data;
            this.key++;
          });
      }
      if (this.installation.activeInstallPhoto && this.installation.activeInstallPhoto != ""&&!this.installation.activeInstallPhoto.includes('base64')) {
        Api()
          .post("/aws/s3/getObject", {
            url: this.installation.activeInstallPhoto,
          })
          .then((response) => {
            this.activeInstallPhoto = response.data;
            this.key++;
          });
      }
      if (this.installation.labellingPhoto && this.installation.labellingPhoto != ""&&!this.installation.labellingPhoto.includes('base64')) {
        Api()
          .post("/aws/s3/getObject", {
            url: this.installation.labellingPhoto,
          })
          .then((response) => {
            this.labellingPhoto = response.data;
            this.key++;
          });
      }
      if (this.installation.incompletePhoto && this.installation.incompletePhoto != ""&&!this.installation.incompletePhoto.includes('base64')) {
        Api()
          .post("/aws/s3/getObject", {
            url: this.installation.incompletePhoto,
          })
          .then((response) => {
            this.incompletePhoto = response.data;
            this.key++;
          });
      }

      this.installTabs = [];
      this.installTabs.push({ name: "installSummary", displayName: "Summary" });

      if (this.installation.isActiveInstall) {
        this.installTabs.push({ name: "activeInstall", displayName: "Active Install" });
      }
      if (this.installation.isPassiveInstall) {
        this.installTabs.push({ name: "passiveInstall", displayName: "Passive Install" });
      }
      this.displayInstallContents("installSummary");
      this.setActiveInstallTabName("installSummary");
      this.key++;
      this.addInstallationModal = true;
    },
    async initialise() {
      this.setActiveTabName("completeInstalls");
      this.setActiveInstallTabName("installSummary");
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    displayInstallContents(name) {
      return this.activeInstallTab === name;
    },
    setActiveInstallTabName(name) {
      this.activeInstallTab = name;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    downloadImg(img) {
      let split = img.split("data:image/jpeg;base64,");
      console.log(split);
      window.location.href = "data:application/octet-stream;base64," + split[1];
    },
  },
};
</script>
